import { render, staticRenderFns } from "./creditReportingServicePage.vue?vue&type=template&id=0983effe&scoped=true&"
import script from "./creditReportingServicePage.vue?vue&type=script&lang=ts&"
export * from "./creditReportingServicePage.vue?vue&type=script&lang=ts&"
import style0 from "./creditReportingServicePage.vue?vue&type=style&index=0&id=0983effe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0983effe",
  null
  
)

export default component.exports